const state = {
  middelNavFixed: false,
}
const getters = {
  isMiddleNavFixed: state => {
    return state.middelNavFixed;
  }
}
const mutations = {
  MIDDLE_NAV_FIXED_STAUS(state, fixed) {
    state.middelNavFixed = (fixed === true);
  }
}

const actions = {
  setMiddleNavFixed({
    commit
  }, fixed) {
    commit('MIDDLE_NAV_FIXED_STAUS', fixed);
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mid-nav-fixed.js